<template>
  <div class="card">
    <div
      class="card-body py-3 d-flex justify-content-between align-items-center"
    >
      <h2 class="h5 mb-0 titulo_pagina">Abonos</h2>
    </div>

    <div class="card-body pt-0">
      <div v-if="mensajeOk" class="alert alert-success py-2" role="alert">
        {{ mensajeOk }}
      </div>

      <div v-if="loading" class="text-center py-5">
        <Loading mensaje="Cargando abonos…" />
      </div>

      <div v-else-if="error" class="alert alert-danger" role="alert">
        <ErrorCarga :errorMsg="errorMsg" @retry="fetchAbonos" />
      </div>

      <div
        v-else-if="abonos.length === 0"
        class="alert alert-info mb-0"
        role="alert"
      >
        <SinDatos mensaje="No hay abonos cargados por el momento." />
      </div>

      <div v-else class="table-responsive fo-table-wrap">
        <table class="table table-sm table-hover align-middle mb-0 fo-table">
          <thead>
            <tr>
              <th>Deporte</th>
              <th>Cliente</th>
              <th>Cancha</th>
              <th>Día</th>
              <th>Desde</th>
              <th>Hasta</th>
              <th>Vigencia</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="a in abonos" :key="a.id_abono">
              <td>{{ a.deporte_desc }}</td>
              <td>{{ a.cliente_nombre }}</td>
              <td>{{ a.cancha }}</td>
              <td>{{ a.dia }}</td>
              <td>{{ a.hora_desde }}</td>
              <td>{{ a.hora_hasta }}</td>
              <td>{{ a.vigencia }}</td>
              <td class="text-nowrap">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary me-2"
                  @click="editarAbono(a)"
                >
                  Editar
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  @click="eliminarAbono(a)"
                >
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div
    v-if="modalAbierto"
    class="modal fade show d-block"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Modificar abono</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Cerrar"
            @click="cerrarModal"
          ></button>
        </div>

        <div class="modal-body">
          <div v-if="errorModal" class="alert alert-danger py-2">
            {{ errorModal }}
          </div>

          <div class="row g-3">
            <div class="col-12 col-md-6">
              <label class="form-label">Deporte</label>
              <select
                v-model.number="form.idDeporte"
                class="form-select"
                @change="onCambioDeporte"
              >
                <option :value="null" disabled>Seleccionar</option>
                <option
                  v-for="d in deportes"
                  :key="d.idDeporte"
                  :value="d.idDeporte"
                >
                  {{ d.descripcion }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Cancha</label>
              <select
                v-model.number="form.idCancha"
                class="form-select"
                :disabled="!form.idDeporte || cargandoCanchas"
              >
                <option :value="null" disabled>Seleccionar</option>
                <option
                  v-for="c in canchas"
                  :key="c.id_cancha"
                  :value="c.id_cancha"
                >
                  {{ c.descripcion }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Cliente</label>
              <select v-model.number="form.idCliente" class="form-select">
                <option :value="null" disabled>Seleccionar</option>
                <option
                  v-for="c in clientes"
                  :key="c.id_cliente"
                  :value="c.id_cliente"
                >
                  {{ c.nombre }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Día</label>
              <select v-model.number="form.idDia" class="form-select">
                <option :value="null" disabled>Seleccionar</option>
                <option v-for="d in dias" :key="d.id_dia" :value="d.id_dia">
                  {{ d.descripcion }}
                </option>
              </select>
            </div>

            <div class="col-6">
              <label class="form-label">Desde</label>
              <input
                v-model="form.horaDesde"
                type="time"
                class="form-control"
                :step="minDivisionTurno * 60"
              />
            </div>

            <div class="col-6">
              <label class="form-label">Hasta</label>
              <input
                v-model="form.horaHasta"
                type="time"
                class="form-control"
                :step="minDivisionTurno * 60"
              />
            </div>

            <div class="col-12">
              <small class="text-muted">
                Los horarios deben respetar intervalos de
                {{ minDivisionTurno }} minutos. Al guardar se actualizarán las
                reservas desde hoy en adelante.
              </small>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            :disabled="guardando"
            @click="cerrarModal"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="guardando"
            @click="guardarAbono"
          >
            {{ guardando ? "Guardando…" : "Guardar cambios" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="modalAbierto" class="modal-backdrop fade show"></div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import Loading from "@/components/Loading.vue";
import ErrorCarga from "@/components/ErrorCarga.vue";
import SinDatos from "@/components/SinDatos.vue";
import { confirm } from "@/composables/useConfirm";
import { formatHora, formatFecha } from "@/utils/fecha";
import {
  apiDeleteAbono,
  apiGetAbonos,
  apiGetCanchasPorDeporte,
  apiGetClientes,
  apiGetDeportesActivos,
  apiGetDias,
  apiPutAbono,
} from "@/api.js";

const loading = ref(true);
const error = ref(false);
const errorMsg = ref("");
const mensajeOk = ref("");
const abonos = ref([]);
const deportes = ref([]);
const clientes = ref([]);
const dias = ref([]);
const canchas = ref([]);
const cargandoCanchas = ref(false);
const modalAbierto = ref(false);
const guardando = ref(false);
const errorModal = ref("");
let controller = null;

const form = ref({
  idAbono: null,
  idDeporte: null,
  idCancha: null,
  idCliente: null,
  idDia: null,
  horaDesde: "",
  horaHasta: "",
});

const minDivisionTurno = computed(() => {
  const deporte = deportes.value.find(
    (d) => d.idDeporte === form.value.idDeporte,
  );
  return Number(deporte?.minDivisionTurno ?? 5);
});

onMounted(async () => {
  await Promise.all([fetchCatalogos(), fetchAbonos()]);
});

async function fetchCatalogos() {
  try {
    const [dataDeportes, dataClientes, dataDias] = await Promise.all([
      apiGetDeportesActivos(),
      apiGetClientes(),
      apiGetDias(),
    ]);

    const listaDeportes = Array.isArray(dataDeportes)
      ? dataDeportes
      : dataDeportes?.items ?? [];
    deportes.value = listaDeportes.map((d) => ({
      idDeporte: d.id_deporte ?? d.idDeporte,
      descripcion: d.descripcion ?? d.nombre ?? "",
      minDivisionTurno: Number(d.min_division_turno ?? d.minDivisionTurno ?? 5),
    }));

    clientes.value = Array.isArray(dataClientes)
      ? dataClientes
      : dataClientes?.items ?? [];
    dias.value = Array.isArray(dataDias) ? dataDias : dataDias?.items ?? [];
  } catch (e) {
    console.error("Error cargando catálogos de abonos", e);
  }
}

async function fetchAbonos() {
  loading.value = true;
  error.value = false;
  errorMsg.value = "";

  try {
    controller?.abort?.();
  } catch {}
  controller =
    typeof AbortController !== "undefined" ? new AbortController() : null;

  try {
    const data = await apiGetAbonos({ signal: controller?.signal });
    const lista = Array.isArray(data)
      ? data
      : data?.results ?? data?.items ?? [];

    abonos.value = lista.map((x) => ({
      id_abono: x.id_abono,
      id_deporte: x.id_deporte,
      id_cancha: x.id_cancha,
      id_cliente: x.id_cliente,
      id_dia: x.id_dia,
      deporte_desc: x.deporte_desc ?? "",
      cliente_nombre: x.cliente_nombre ?? x.cliente ?? "",
      cancha: x.cancha ?? x.cancha_desc ?? "",
      dia: x.dia ?? x.dia_desc ?? "",
      hora_desde: formatHora(x.hora_desde) ?? "",
      hora_hasta: formatHora(x.hora_hasta) ?? "",
      vigencia: formatFecha(x.alta_fecha) ?? "",
    }));
  } catch (e) {
    console.error(e);
    error.value = true;
    errorMsg.value =
      "No se pudieron cargar los abonos. Intente nuevamente por favor.";
  } finally {
    loading.value = false;
  }
}

async function cargarCanchas(idDeporte) {
  canchas.value = [];
  if (!idDeporte) return;

  cargandoCanchas.value = true;
  try {
    const data = await apiGetCanchasPorDeporte({ idDeporte });
    canchas.value = Array.isArray(data) ? data : data?.items ?? [];
  } catch (e) {
    console.error("Error cargando canchas", e);
    errorModal.value =
      "No se pudieron cargar las canchas del deporte seleccionado.";
  } finally {
    cargandoCanchas.value = false;
  }
}

async function editarAbono(abono) {
  errorModal.value = "";
  form.value = {
    idAbono: abono.id_abono,
    idDeporte: abono.id_deporte,
    idCancha: abono.id_cancha,
    idCliente: abono.id_cliente,
    idDia: abono.id_dia,
    horaDesde: abono.hora_desde,
    horaHasta: abono.hora_hasta,
  };

  await cargarCanchas(form.value.idDeporte);
  modalAbierto.value = true;
}

async function onCambioDeporte() {
  form.value.idCancha = null;
  errorModal.value = "";
  await cargarCanchas(form.value.idDeporte);
}

function cerrarModal() {
  if (guardando.value) return;
  modalAbierto.value = false;
  errorModal.value = "";
}

function horaAMinutos(hora) {
  if (!hora || !/^\d{2}:\d{2}$/.test(hora)) return null;
  const [h, m] = hora.split(":").map(Number);
  return h * 60 + m;
}

function validarFormulario() {
  if (!form.value.idCancha || !form.value.idCliente || !form.value.idDia) {
    return "Completá deporte, cancha, cliente y día.";
  }

  const desde = horaAMinutos(form.value.horaDesde);
  const hasta = horaAMinutos(form.value.horaHasta);

  if (desde == null || hasta == null)
    return "Completá los horarios desde y hasta.";
  if (desde >= hasta) return "La hora desde debe ser menor que la hora hasta.";

  const division = minDivisionTurno.value;
  if ((desde % 60) % division !== 0 || (hasta % 60) % division !== 0) {
    return `Los horarios deben respetar intervalos de ${division} minutos.`;
  }

  return "";
}

function horaApi(hora) {
  if (!hora) return null;

  if (/^\d{2}:\d{2}$/.test(hora)) {
    return `${hora}:00`;
  }

  return hora;
}

async function guardarAbono() {
  errorModal.value = validarFormulario();
  if (errorModal.value) return;

  guardando.value = true;
  try {
    await apiPutAbono(form.value.idAbono, {
      id_cancha: form.value.idCancha,
      id_dia: form.value.idDia,
      hora_desde: horaApi(form.value.horaDesde),
      hora_hasta: horaApi(form.value.horaHasta),
      id_cliente: form.value.idCliente,
    });

    modalAbierto.value = false;
    mensajeOk.value =
      "El abono se modificó correctamente. Las reservas futuras fueron regeneradas.";
    await fetchAbonos();
    setTimeout(() => (mensajeOk.value = ""), 4500);
  } catch (e) {
    console.error(e);
    errorModal.value = obtenerMensajeErrorApi(
      e,
      "No se pudo modificar el abono.",
    );
  } finally {
    guardando.value = false;
  }
}

async function eliminarAbono(abono) {
  const ok = await confirm({
    title: "Eliminar abono",
    message: `¿Seguro que querés eliminar el abono de ${abono.cliente_nombre}? Las reservas desde hoy en adelante también se darán de baja.`,
    confirmText: "Sí, eliminar",
    cancelText: "No, cancelar",
    confirmClass: "btn-danger",
    panelClass: "w-100 w-md-50",
  });

  if (!ok) return;

  try {
    await apiDeleteAbono(abono.id_abono);
    mensajeOk.value =
      "El abono se eliminó correctamente. Las reservas pasadas se conservaron como historial.";
    await fetchAbonos();
    setTimeout(() => (mensajeOk.value = ""), 4500);
  } catch (e) {
    console.error(e);
    error.value = true;
    errorMsg.value = obtenerMensajeErrorApi(e, "No se pudo eliminar el abono.");
  }
}

function obtenerMensajeErrorApi(e, fallback) {
  return e?.data?.detail || e?.detail || e?.message || fallback;
}
</script>
